import { urijs } from '@wix/communities-blog-client-common';

const getPostUrl = (topology, paths) =>
  urijs
    .joinPaths(urijs(topology.baseUrl).pathname(), topology.postPagePath, ...paths)
    .absoluteTo(topology.baseUrl)
    .toString();

export default getPostUrl;
